import React from 'react';

const ImageStack = ({ images }) => {
  return (
    <div className="image-stack">
      {images.map((image, index) => (
        <img
          key={index}
          src={image}
          alt={`Image ${index + 1}`}
          className="stacked-image"
        />
      ))}
    </div>
  );
};

export default ImageStack;